import { Application, ApplicationType } from '../constants/app';
import { Content, TShopAdditionalContentMenu, TShopAuthStatus, TShopMenu } from '../../entities/content';
import { getUsername } from '../helper';
import { navStateStore } from '../../state/nav-state-store';
import { navContentStore } from '../../state/nav-content-store';
import { shopStateStore, ShopStateStoreTypes } from '../../state/shop-state-store';

export function isShopAvailable(locale: string, app: ApplicationType): boolean {
  const shopList = navContentStore.state.shop?.availableLocales;
  return shopList !== undefined && shopList.includes(locale) && app === Application.shop;
}

function logoLinksToShop(locale: string): boolean {
  return navContentStore.state.shop?.logoLinksToShopLocales?.includes(locale) || false;
}

export function isShopAvailableAndLogoLinksToShop(
  locale: string,
  app: ApplicationType,
  shop: TShopMenu | null
): shop is TShopMenu {
  return isShopAvailable(locale, app) && logoLinksToShop(locale) && shop !== null;
}

export function removeShopItemForNonShopContexts(
  locale: string,
  app: ApplicationType | undefined,
  content: Content
): Content {
  const { shop, externalShop } = content;

  if (shop === null) return content;

  if (externalShop && app !== Application.shop) {
    return {
      ...content,
      shop: {
        ...shop,
        ...externalShop
      }
    };
  }

  if (
    !shop?.availableLocales.includes(locale) ||
    (shop?.availableLocalesOnlyForShop.includes(locale) && app !== Application.shop)
  ) {
    return {
      ...content,
      shop: {
        ...shop,
        text: ''
      }
    };
  }

  return content;
}

export function filterWishlistItemsByAuthStatus(
  menuItems: TShopAdditionalContentMenu[],
  authStatusList: TShopAuthStatus[]
): TShopAdditionalContentMenu[] {
  return menuItems?.filter((item) => {
    if (item.authStatus === null || item.authStatus === undefined) {
      return authStatusList.includes(null);
    }

    return authStatusList.includes(item.authStatus);
  });
}

export function getAvailableShopVariables(): { wishlistItemsNumber: number; username: string } {
  const { myPorsche } = navContentStore.state;
  const { loggedInState } = navStateStore.state;
  let { wishlistItemsNumber } = shopStateStore.state.shopInformation;

  if (wishlistItemsNumber === 0) {
    wishlistItemsNumber = shopStateStore.state.wishlistItemsNumber;
  }

  const username = getUsername(loggedInState, myPorsche?.loggedInFallback || '');

  return { wishlistItemsNumber, username };
}

export function loadsShopPropsOnStore(props: ShopStateStoreTypes): void {
  shopStateStore.set('wishlistItemsNumber', props.wishlistItemsNumber);
  shopStateStore.set('numberOfShoppingItems', props.numberOfShoppingItems);
  shopStateStore.set('shopInformation', props.shopInformation);
}

function getWishlistIconName(): string {
  const { shopInformation } = shopStateStore.state;
  const { wishlistItemsNumber } = shopStateStore.state;
  const wishlistNumber =
    shopInformation.wishlistItemsNumber > 0 ? shopInformation.wishlistItemsNumber : wishlistItemsNumber;

  return wishlistNumber > 0 ? 'heart-filled' : 'heart';
}

export function getIconNameByMenuItemId(id: string): string | null {
  const iconsGetterFunctions: Record<string, () => string> = {
    wishlist: getWishlistIconName
  };

  const getIconName = iconsGetterFunctions[id];

  if (typeof getIconName !== 'function') return null;

  return getIconName();
}
